import React from "react";
import "../../components/common/text-color/textColor.css";

const CommonLabel = ({ htmlFor, labelText }) => {
  return (
    <label htmlFor={htmlFor} name={htmlFor} style={{ display: "none" }}>
      <span className='text-s text-color-blue'>{labelText}</span>
    </label>
  );
};

export const LabelValueForSale = ({ label, value }) => {
  return (
    <div className='mb-2 flex w-full'>
      <div className='w-2/3 text-gray-500 dark:text-white text-xs'>
        {label}:
      </div>
      <div className='w-1/3 dark:text-white text-xs'>{value}</div>
    </div>
  );
};
export const LabelValueForExpense = ({ label, value }) => {
  return (
    <div className='mb-1 flex w-full'>
      <div className='w-2/3 dark:text-white text-xs'>{label}:</div>
      <div className='text-black capitalize dark:text-white text-xs'>
        {value}
      </div>
    </div>
  );
};
export const IncomeTypeDisplay = ({ label, value }) => {
  return (
    <div className='mb-1 flex w-full'>
      <div className='w-2/3 dark:text-white text-xs'>{label}:</div>
      <div className='text-black capitalize dark:text-white text-xs'>
        {value}
      </div>
    </div>
  );
};
export const LabelValueWithLink = ({ label, link }) => {
  const handleDocumentClick = (e, documentLink) => {
    e.preventDefault();
    if (!documentLink) return;

    // Check if the link is valid and not empty
    try {
      const url = new URL(documentLink);
      if (url.href) {
        window.open(documentLink, "_blank", "noopener,noreferrer");
      }
    } catch (error) {
      console.error("Invalid document URL:", error);
      // Optionally show a user-friendly message
    }
  };

  // Only render if there's a valid link
  if (!link) return null;

  return (
    <div className='mb-1 flex w-full'>
      <div className='w-2/3 font-medium dark:text-white '>{label}:</div>
      <div className='text-black capitalize dark:text-white'>
        <a
          href={link}
          onClick={(e) => handleDocumentClick(e, link)}
          target='_blank'
          rel='noopener noreferrer'
          className='text-blue-500 hover:text-blue-700 underline cursor-pointer'
        >
          Download
        </a>
      </div>
    </div>
  );
};
export const ToggleButton = ({
  value,
  onToggle,
  activeColor,
  inactiveColor,
  label,
  secondaryLabel,
  secondaryPosition,
}) => {
  return (
    <div className='relative flex items-center'>
      {secondaryLabel && secondaryPosition === "left" && (
        <span className='text-xs text-color-blue font-semibold mr-2 dark:text-white'>
          {secondaryLabel}
        </span>
      )}

      <button
        type='button'
        onClick={onToggle}
        className={`${
          value ? activeColor : inactiveColor
        } w-9 h-7 rounded-full focus:outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-blue-500 transition-colors duration-300 ease-in-out`}
        style={{ height: "20px" }}
      >
        <span
          className={`${
            value ? "translate-x-7" : "translate-x-2"
          } inline-block w-4 h-4 bg-white rounded-full border border-gray-500 transform transition-transform duration-300 ease-in-out`}
          style={{
            marginLeft: "-35px",
            marginTop: 2.5,
          }}
        ></span>
      </button>

      {/* Conditional rendering for the secondary label on the right */}
      {secondaryLabel && secondaryPosition === "right" && (
        <span className='text-xs text-color-blue font-semibold ml-2 dark:text-white'>
          {secondaryLabel}
        </span>
      )}

      {/* Primary label after the button */}
      {label && (
        <span className='text-xs text-color-blue font-semibold ml-2 dark:text-white'>
          {label}
        </span>
      )}
    </div>
  );
};

export default CommonLabel;
